import type { LucideIcon } from 'lucide-react';
import { cn } from '../../lib/cn';

export function EmptyState({
  icon: Icon,
  title,
  body,
  action,
  className,
}: {
  icon?: LucideIcon;
  title: string;
  body?: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('empty-state', className)}>
      {Icon ? <Icon size={32} strokeWidth={1.5} className="empty-state-icon" /> : null}
      <h3 className="empty-state-title">{title}</h3>
      {body ? <p className="empty-state-body">{body}</p> : null}
      {action ? <div className="empty-state-action">{action}</div> : null}
    </div>
  );
}
